module.exports = __webpack_public_path__ + "img/2.9f53e453.png";